import { render, staticRenderFns } from "./EditOrderItems.vue?vue&type=template&id=8ad1c16e&scoped=true"
import script from "./EditOrderItems.vue?vue&type=script&lang=js"
export * from "./EditOrderItems.vue?vue&type=script&lang=js"
import style0 from "./EditOrderItems.vue?vue&type=style&index=0&id=8ad1c16e&prod&lang=scss"
import style1 from "./EditOrderItems.vue?vue&type=style&index=1&id=8ad1c16e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad1c16e",
  null
  
)

export default component.exports